import { authTokenHandler } from "@/feature-auth/utils/auth-token-handler.mjs";

export default async function getBearerToken(): Promise<string | null> {
  const authToken = await authTokenHandler.getToken();

  if (!authToken) return null;

  return `Bearer ${authToken}`;
}
